{
  "name": "tunnel",
  "doc": "The oldest trick: a slow pull toward the centre, nothing else. Every injected wave becomes a ring that shrinks into the eye; the centre is darkened so the eye stays black.",
  "cx": 0.5,
  "cy": 0.5,
  "zoom": 1.03,
  "zoomexp": 1.0,
  "rot": 0.0,
  "rotr": 0.0,
  "dx": 0,
  "dy": 0,
  "sx": 1,
  "sy": 1,
  "warp": 0,
  "warpScale": 4,
  "warpSpeed": 0.3,
  "decay": 0.96,
  "invert": 0,
  "hueShift": 0.003,
  "darkenCenter": 0.6,
  "wave": "CIRCLE",
  "waveColor": 1,
  "shapes": 0,
  "energy": [
    0.35,
    0.8
  ]
}